import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { HeaderData, DetailMenu, Breadcrumbs } from 'src/app/_models/header-data';
import { FORM_MSGS, RESULTS_NOT_FOUND, SUBMISSION_MSGS, FILE_UPLOAD_CONFIG } from 'src/app/_common/product-config';
import { SubmissionsService } from '../_services/submissions.service';
import { Submission } from '../_models/submission';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SubmissionSteps, ClearAccountIndicators, NewBusiness, Channel, DandBEventsTypes } from 'src/app/_common/_enum/module.enum';
import { environment } from 'src/environments/environment';
import LogRocket from 'logrocket';
import { Router, ActivatedRoute } from '@angular/router';
import { SubmissionBasicInfoComponent } from '../submission-basic-info/submission-basic-info.component';
import { SubmissionCoverageComponent } from '../submission-coverage/submission-coverage.component';
import { SubmissionAttachmentsComponent } from '../submission-attachments/submission-attachments.component';
import { SubmissionReviewComponent } from '../submission-review/submission-review.component';
import { Observable } from 'rxjs';
import { ComponentCanDeactivate } from 'src/app/_helpers/pending-changes-guard.guard';
import { DnBEventLog } from 'src/app/_models/event-logging';
import {v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-create-submission',
  templateUrl: './create-submission.component.html',
  styleUrls: ['./create-submission.component.scss']
})
export class CreateSubmissionComponent implements OnInit, ComponentCanDeactivate {

  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;

  public loading: boolean = false; //Using it in HTML
  public submitLoading: boolean = false; //Using it in HTML
  private hasAccess: boolean = true; //Using it in HTML
  private hasError: boolean = false;

  private _submission: Submission;
  private submissionData;

  private submissionSteps = SubmissionSteps;
  private clearAccountIndicators = ClearAccountIndicators;
  
  private resultsNotFound = RESULTS_NOT_FOUND; //Using it in HTML
  private submissionMsgs = SUBMISSION_MSGS; //Using it in HTML
  private formMsgs = FORM_MSGS; //Using it in HTML
  private fileUploadConfig = FILE_UPLOAD_CONFIG; //Using it in HTML

  private modalReference;

  private referenceData = {};
  private isSubmitted: boolean = false;
  
  private selectedNiche: any;
  private selectedProducer: any;

  private isBusinessLookup: boolean;

  private submissionId: string = "";

  private dnbEventsModel: DnBEventLog;
  private dnbEventsTypes = DandBEventsTypes;
  private currentUserDts: any;

  private uploadedFileSize: number = 0;

  @ViewChild("discardSubmissionModal", {static: false}) discardSubmissionModal;
  @ViewChild(SubmissionBasicInfoComponent, {static: false}) submissionBasicInfo:SubmissionBasicInfoComponent;
  @ViewChild(SubmissionCoverageComponent, {static: false}) submissionCoverage:SubmissionCoverageComponent;
  @ViewChild(SubmissionAttachmentsComponent, {static: false}) submissionAttachments:SubmissionAttachmentsComponent;
  @ViewChild(SubmissionReviewComponent, {static: false}) submissionReview:SubmissionReviewComponent;
  constructor(public readonly route: ActivatedRoute, private readonly router: Router, private modalService : NgbModal, private submissionService: SubmissionsService) { }

  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    // insert logic to check if there are pending changes here;
    // returning true will navigate without confirmation
    // returning false will show a confirm dialog before navigating away
    return (!this.selectedNiche && !this.selectedProducer) || this.isBusinessLookup || this._submission.selectedStep == this.submissionSteps.Success || this.hasError;
  }

  ngOnInit() {
    /** TODO: Check if logged in user have permission for Submission */
    this._submission = new Submission();
    this.submissionData = this._submission.submissionData;
    this.submissionService.resetSupportingDocuments();

    this.loading = false;
    this.submitLoading = false;
    this.hasAccess = true;

    this.submissionService.selectedNiche = history.state.selectedNiche;
    this.submissionService.selectedProducer = history.state.selectedProducer;
    this.selectedNiche = history.state.selectedNiche;
    this.selectedProducer = history.state.selectedProducer;
    this.isBusinessLookup = history.state.isBusinessLookup;

    /** Set Initial DnB Event Model */
    this.setInitialDnBEventLogModel();
    
    if(this.selectedNiche && this.selectedProducer){
      /* Setting Headers Starts */
      this.headerData = new HeaderData();
      this.setHeaderData();
      /* Setting Headers Ended */

      
      this._submission.submissionData.producerCode = this.selectedProducer.code;
      this._submission.submissionData.producerName = this.selectedProducer.name;
      this._submission.submissionData.producerCity = this.selectedProducer.producerCity;
      this._submission.submissionData.producerState = this.selectedProducer.producerState;
      this._submission.submissionData.niche = this.selectedNiche.nicheName;
    }
    else{
      this.router.navigate(["newbusiness"], {state: {selectedBusiness: NewBusiness.SUBMISSIONS}});
    }
    
    this.fetchReferenceData();

    this._submission.selectedStep = SubmissionSteps.BasicInfo;

    /* if(this._submission.selectedStep){
      this.selectedStep = this._submission.selectedStep;
    }else{
      this._submission.selectedStep = SubmissionSteps.BasicInfo;
    } */
    this.submission = this._submission;
  }

  setHeaderData(){
    this.headerData.pageTitle = "Create New Submission";
    this.headerData.breadcrumb = null;
    this.headerData.detailMenuClass = "text-left";
    this.headerData.detailMenu = [{label: "PRODUCT", description: this.selectedNiche.nicheName}, {label: "PRODUCER", description: this.selectedProducer.code}];

    this.submissionService.header = this.headerData;
  }

  getContinueButtonName(){
    this._submission = this.submission;
    if(this._submission.selectedStep == this.submissionSteps.BasicInfo){
      return (this._submission.isExistingAccount != null)?"Continue to Coverage":"Continue";
    }else if(this._submission.selectedStep == this.submissionSteps.Coverage){
      return "Continue to Attachments";
    }else if(this._submission.selectedStep == this.submissionSteps.Attachments){
      return "Review Submission";
    }else if(this._submission.selectedStep == this.submissionSteps.Review){
      return "Submit Business";
    }
  }

  fetchReferenceData(){   
    this.loading = true; 
    
    let lookupSubscription =  this.submissionService.fetchReferenceData().subscribe(response=>{
      this.referenceData = response;
      this.loading = false; 
    }, error=>{
      this.hasError = true;
      this.loading = false; 
    });

    this.submissionService.runningServices.push(lookupSubscription);
  }
  
  get selectedStep(){
    return this.submissionService.selectedStep;
  }
  set selectedStep(_step){
    this._submission.selectedStep = _step;
    this.submissionService.selectedStep = _step;
  }
  get submission(){
    return this.submissionService.submission;
  }
  set submission(_submission){
    this.submissionService.submission = _submission;
  }

  get submissionAPILoading(){
    return this.submissionService.loading;
  }

  getUploadedFileSize($event) {
    this.uploadedFileSize = $event;
  }

  selectStep(_step){
    if(this.selectedStep !== this.submissionSteps.BasicInfo && _step == this.submissionSteps.BasicInfo){
      this.selectedStep = _step;
    }else if(this.selectedStep === this.submissionSteps.Coverage && _step == this.submissionSteps.BasicInfo){
      this.selectedStep = _step;
    }else if(this.selectedStep === this.submissionSteps.Attachments && _step != this.submissionSteps.Review){
      this.selectedStep = _step;
    }else if(this.selectedStep === this.submissionSteps.Review && _step != this.submissionSteps.Review){
      this.selectedStep = _step;
    }

    this._submission.selectedStep = this.selectedStep;

    this.submission = this._submission;
  }
  
  public onDiscard(){
    this.router.navigate(["newbusiness"], {state: {selectedBusiness: NewBusiness.SUBMISSIONS}});
    if(environment.logRocketKey){
      LogRocket.log("(LogRocket) DiscardSubmission : " + true);
      let loggedInUser = this.submissionService.getLoggedInProfile();
      LogRocket.identify(loggedInUser.UID.toString(), {
        DiscardSubmission: true
      });
    }
  }
  
  goToDetails(_showAttachments=false){
    this.router.navigate(["newbusiness/submissions/" + this.submissionId], {state: {showAttachments: _showAttachments}});
  }
  
  public onContinue():void{
    this.isSubmitted = true;
    if(this.selectedStep == SubmissionSteps.BasicInfo){
      if(this.submissionBasicInfo.onContinue()){
        let loggedInProfile = this.submissionService.getLoggedInProfile();
        this._submission.submissionData.submittedBy = loggedInProfile.firstName + ' ' + loggedInProfile.lastName;
        this._submission.submissionData.submittedEmail = loggedInProfile.email;
        if(this._submission.submissionData.riskState==''){
          this._submission.submissionData.riskState = this._submission.submissionData.addresses[0].state;
        }
        this.selectedStep = this.submissionSteps.Coverage;
        this.submission.selectedStep = this.submissionSteps.Coverage;
        this.submission = this._submission;
        window.scrollTo(0, 0);
      }else{
        console.log("invalid basic info continue");
      }
       // this.endorsement.supportingDocuments = newSupportingDocuments;
    }else if(this.selectedStep == SubmissionSteps.Coverage){
      if(this.submissionCoverage.onContinue()){
        this.selectedStep = this.submissionSteps.Attachments;
        this.submission.selectedStep = this.submissionSteps.Attachments;
        this.submission = this._submission;
        window.scrollTo(0, 0);
      }else{
        console.log("invalid coverage continue");
      }
    }else if(this.selectedStep == SubmissionSteps.Attachments){
      if(this.submissionAttachments.onContinue()){
        this.selectedStep = this.submissionSteps.Review;
        this.submission.selectedStep = this.submissionSteps.Review;
        this.submission = this._submission;
        window.scrollTo(0, 0);
      }else{
        console.log("invalid attachments continue");
      }
    }else if(this.selectedStep == SubmissionSteps.Review){
      if(this._submission.submissionData.accountLegalEntity && this._submission.submissionData.accountLegalEntity.code){
        this._submission.submissionData.accountLegalEntity = this._submission.submissionData.accountLegalEntity.code;
      }

      this._submission.submissionData.coverages.forEach(_coverage => {
        let _underwriter = _coverage.underwriters.find((_underwriter)=>{return _underwriter.underwriterEmailAddress === this._submission.underwriter.underwriterEmailAddress});
        
        _coverage.underwriters = null;
        if(_underwriter){
          _coverage.underwriters = [_underwriter];
        }
      });
      
      this._submission.submissionData.coverages.forEach(_coverage => {
        if(_coverage.underwriters && _coverage.underwriters.length > 0){
          _coverage.underwriter = _coverage.underwriters[0].underwriterName;
          _coverage.underwriterEmailAddress = _coverage.underwriters[0].underwriterEmailAddress;
          _coverage.underwriterNetworkName = _coverage.underwriters[0].underwriterNetworkName;
        }else{
          _coverage.underwriter = null;
          _coverage.underwriterEmailAddress = null;
          _coverage.underwriterNetworkName = null;
        }
      });

      //phone number special character removal logic
      if(this._submission.submissionData.contact && this._submission.submissionData.contact.phone && this._submission.submissionData.contact.phone.includes("(" || ")" || " " || "-")){
        this._submission.submissionData.contact.phone = this._submission.submissionData.contact.phone.replace(/[^0-9]/g, "");
      }

      //Remove Contacts if no name entered
      if((this._submission.submissionData.contact.firstName === null || this._submission.submissionData.contact.firstName === undefined || this._submission.submissionData.contact.firstName === '') && 
      (this._submission.submissionData.contact.lastName === null ||  this._submission.submissionData.contact.lastName === undefined || this._submission.submissionData.contact.lastName === '') && 
      (this._submission.submissionData.contact.phone === null || this._submission.submissionData.contact.phone === undefined || this._submission.submissionData.contact.phone === '') && 
      (this._submission.submissionData.contact.email === null || this._submission.submissionData.contact.email === undefined || this._submission.submissionData.contact.email === '')){
        this._submission.submissionData.contact = null;
      }

      //If their is more than one address entered, check if any addresses are missing the required information and remove them from the list
      if(this._submission.submissionData.addresses.length > 1){
        let _validAddress = [];
        for(let addressIndex in this._submission.submissionData.addresses)
        {
          if(this._submission.submissionData.addresses[addressIndex] === null ||  this._submission.submissionData.addresses[addressIndex] === undefined || 
          (this._submission.submissionData.addresses[addressIndex].zip === null || this._submission.submissionData.addresses[addressIndex].zip === undefined || this._submission.submissionData.addresses[addressIndex].zip === '') || 
          (this._submission.submissionData.addresses[addressIndex].city === null ||  this._submission.submissionData.addresses[addressIndex].city === undefined || this._submission.submissionData.addresses[addressIndex].city === '') || 
          (this._submission.submissionData.addresses[addressIndex].state === null || this._submission.submissionData.addresses[addressIndex].state === undefined || this._submission.submissionData.addresses[addressIndex].state === '') || 
          (this._submission.submissionData.addresses[addressIndex].addressLine1 === null || this._submission.submissionData.addresses[addressIndex].addressLine1 === undefined || this._submission.submissionData.addresses[addressIndex].addressLine1 === '')){
            this._submission.submissionData.addresses[addressIndex] = null;
          }
          else{
            _validAddress.push(this._submission.submissionData.addresses[addressIndex]);
          }
        }
        this._submission.submissionData.addresses = _validAddress;
      }

      this.submission = this._submission;
      window.scrollTo(0, 0);

      console.log("uploading files");
      LogRocket.log("uploading files");
      let newSupportingDocuments = [];
      this.loading = true;
      this.submitLoading = true;
      let supportedDocuments = this.submissionService.getSupportingDocuments();
      if(supportedDocuments.length>0){
        supportedDocuments.forEach((document, index) => {
           let newFile:any = {};
            newFile.fileName= document.name;
            newFile.fileType= document.type;
            newFile.documentType = document.documentType;

            ((_document, _newFile)=>{
              let fReader = new FileReader();
              // Add complete behavior
              fReader.onload = ()=>{
                _newFile.contentStream = fReader.result;
                _newFile.contentStream = _newFile.contentStream.split("base64,")[1];

                //console.log(_newFile.contentStream);
                newSupportingDocuments.push(_newFile);

                if(newSupportingDocuments.length == supportedDocuments.length){
                  this.submitRequest(newSupportingDocuments);
                }else{
                  console.log("uploading file " + index);
                  LogRocket.log("uploading file " + index);
                }
              };
              fReader.readAsDataURL(_document);
            })(document, newFile);   
        });
      }else{
        this.submitRequest([]);
      }

    }else{
      console.log("invalid basic info continue");
    }
  }
  
  submitRequest(newSupportingDocuments){
    console.log("Submitting request");
    LogRocket.log("Submitting request");
    let submissionData = this._submission.submissionData;
    submissionData.attachments = newSupportingDocuments;

    submissionData.submittedBy = "";
    submissionData.submittedDate = "";
    submissionData.submittedEmail = "";    
    
    this.submissionService.submitSubmission(submissionData).subscribe((_data)=>{
      console.log("Submitted!!");
      LogRocket.log("Submitted!!");
      this.loading = false;
      this.submitLoading = false;
      this.submissionService.resetSupportingDocuments();
      this._submission.submissionData.attachments= [];
      this.submissionId = _data.applicationId;
      this.submissionData.accountIndicator = _data.accountIndicator;
      this._submission.submissionData.accountIndicator = _data.accountIndicator;
      /* try{
        this.submission = this._submission;
      }catch(e){
        console.log("Local Storage size exceeding.. Still submission success!");
      } */
      
      if(environment.logRocketKey){
        LogRocket.log("(LogRocket) SubmissionRequestSubmitted : " + true + " with account indicator : " + submissionData.accountIndicator);
        let loggedInUser = this.submissionService.getLoggedInProfile();
        LogRocket.identify(loggedInUser.UID.toString(), {
          SubmissionRequestSubmitted: true
        });
      }
      /* this.selectedStep = this.submissionSteps.Success;
      this.submission.selectedStep = this.submissionSteps.Success; */

      this.dnbEventsModel = this.submissionService.getDnBEventData();
      this.dnbEventsModel.eventType = DandBEventsTypes.ChoiceSubmitted;
      this.dnbEventsModel.accountNumber = _data.accountNumber !== 0 ? _data.accountNumber : null;
      this.submissionService.dnbEventLog(this.dnbEventsModel);

      this._submission = new Submission();
      this._submission.selectedStep = this.submissionSteps.Success;
      this.submission = this._submission;
    },error=>{
      this.hasError = true;          
      this.loading = false;
      this.submitLoading = false;
      this.submissionService.resetSupportingDocuments();
    });
    console.log(JSON.stringify(submissionData));
  }

  setIsBusinessLookup ($event) {
    this.isBusinessLookup = $event;
  }

  setInitialDnBEventLogModel() {
    this.currentUserDts = this.submissionService.getLoggedInProfile();
    this.dnbEventsModel = new DnBEventLog();
    this.dnbEventsModel.channelName = Channel.Submission;
    this.dnbEventsModel.psoUser = this.currentUserDts.email;
    this.dnbEventsModel.userSessionId = this.currentUserDts.SID;
    if(this.selectedNiche)
      this.dnbEventsModel.niche = this.selectedNiche.nicheName;
    if(this.selectedProducer)
      this.dnbEventsModel.producer = this.selectedProducer.code;
    this.dnbEventsModel.flowSessionId = uuidv4();
  }
}
